import { render } from "./Farm.vue?vue&type=template&id=07d0c713&scoped=true"
import script from "./Farm.vue?vue&type=script&lang=js"
export * from "./Farm.vue?vue&type=script&lang=js"

import "./Farm.vue?vue&type=style&index=0&id=07d0c713&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07d0c713"

export default script